import { NavLink, Outlet } from "react-router-dom";

import "./AccountInvoices.css";
import { useState } from "react";
import { messageAndErrorStore, userStore } from "../../store/Store";
import MessageCard from "../../components/MessageCard";
export default function AccountInvoices() {
  // global
  const messageTrigger = messageAndErrorStore((data) => data.messageTrigger);
  const successMessage = messageAndErrorStore(
    (messages) => messages.successMessage,
  );
  const pageError = messageAndErrorStore((messages) => messages.error);
  const currentCompany = userStore((data) => data.currentCompany);
  // local
  const [invoiceTarget, setInvoiceTarget] = useState("");

  
  return (
    <div className="container-fluid">
      {messageTrigger && (
        <MessageCard errorMessage={pageError} successMessage={successMessage} />
      )}
      <div className="d-flex justify-content-between project-header border-bottom">
        <h1>{`${invoiceTarget} Invoices`}</h1>
        <div>
          {currentCompany.full_access && (
            <NavLink
              to={"/account-invoices/customer"}
              className="account-invoice-link"
              onClick={() => setInvoiceTarget("Customer")}
            >
              Customer
            </NavLink>
          )}
          {currentCompany.full_access && (
            <NavLink
              to={"/account-invoices/vendor"}
              className="account-invoice-link"
              onClick={() => setInvoiceTarget("Vendor")}
            >
              Vendor
            </NavLink>
          )}
          {currentCompany.full_access && (
            <NavLink
              to={"/account-invoices/received"}
              className="account-invoice-link"
              onClick={() => setInvoiceTarget("Received")}
            >
              Received
            </NavLink>
          )}
        </div>
        <h1> </h1>
      </div>
      <Outlet context={{ setInvoiceTarget }} />
    </div>
  );
}
